export default __webpack_public_path__ + "static/media/title_th_pc@2x.d9eefb2c.png";